import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 15.9998,
		cy: 16.0013,
		r: 13.8333,
		stroke: "#D9D9D9"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.2351 21.91L9 16.6749L10.4763 15.1986L14.2351 18.9469L22.182 11L23.6583 12.4868L14.2351 21.91Z",
		fill: "#162395"
	})]
});
export default SvgCheckCircleFilled;
